/*
 * File: container.ts
 * File Created: 2023-11-27 03:22:24
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-03-02 10:00:41
 * Modified By: Val Liu
 * -----
 */

import { Config } from "@/../config/default/framework";

var config: Config = {
    validatorAfter: false,
};
export default config;
